import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getOrderDetailById(detailId) {
            var meta = { clientApiMethod: 'getOrderDetailById', input: { detailId: detailId } }
            var response = await client().get(store.state.apiRouteRoot + "orderdetail/get/" + detailId, { meta: meta })
            return response?.data;
        },
        async createOrderDetail(jobId, newdetail) {
            var meta = {
                clientApiMethod: 'createOrderDetail',
                input: { jobId: jobId, newdetail },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().put(store.state.apiRouteRoot + "orderdetail/add/job/" + jobId, newdetail, { meta: meta })
            return response?.data;
        },
        async moveOrderDetail(/*movement*/) {
            store.dispatch('triggerevents/simpleChangeSuccess', { title: i18n.t('servicesystem.common_objects.fallbackterms.Unavailable_Feature'), subtitle: i18n.t('servicesystem.common_objects.fallbackterms.Unavailable_Feature_Body'), icon: "square_foot" });
            /*
            var meta = {
                clientApiMethod: 'moveOrderDetail',
                input: { repaircode },
                successText: i18n.t("servicesystem.responses.moved_orderline")
            }
            var response = await client().patch(store.state.apiRouteRoot + "orderdetail/move", movement, { meta: meta })
            return response?.data;
            */
        },
        async changeOrderDetail(jobId, detail) {
            var meta = {
                clientApiMethod: 'changeOrderDetail',
                input: { jobId: jobId, detail },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "orderdetail/job/" + jobId + "/change/" + detail.Id, detail, { meta: meta })
            return response?.data;
        },
        async deleteOrderDetail(detailId) {
            var meta = {
                clientApiMethod: 'deleteOrderDetail',
                input: { detailId: detailId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "orderdetail/remove/" + detailId, { meta: meta })
            return response?.data;
        },
    }
}